module.exports = __webpack_public_path__ + "static/media/big_dot.ea04a20c.svg";